import styles from '@ui/components/Select/Select.module.scss';
import SelectItemIcon from '@ui/components/Select/components/SelectItemIcon';
import React from 'react';

const SelectLabelSingle = ({ selectedItem, hasIcons, placeholder }) =>
  selectedItem ? (
    <div className={styles.selectedItem}>
      {hasIcons && selectedItem.icon && (
        <>
          <SelectItemIcon
            isImage={selectedItem.icon.includes('/')}
            src={selectedItem.icon}
          />
          <div className={styles.separator} role="presentation" />
        </>
      )}
      <div>{selectedItem.label}</div>
    </div>
  ) : (
    <div className={styles.selectedItem}>
      {hasIcons && (
        <>
          <SelectItemIcon src="list" />
          <div className={styles.separator} role="presentation" />
        </>
      )}
      {placeholder || null}
    </div>
  );

export default SelectLabelSingle;
